module.exports = __webpack_public_path__ + "static/media/sustainable_mobility_revolution.d2cb87de.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable_mobility_revolution.webp
// module id = 315
// module chunks = 0